<template>
  <div>
    <van-nav-bar
      :title="goods.title"
      left-arrow
      class="my-nav"
      @click-left="$router.back(-1)"
      :z-index="100"
    />
    <div class="goods">
      <van-swipe class="goods-swipe" :autoplay="3000">
        <van-swipe-item v-for="thumb in goods.thumb" :key="thumb">
          <img :src="thumb" />
        </van-swipe-item>
      </van-swipe>

      <!--秒杀倒计时-->
      <div class="sec-kill" v-if="secKill.exist">
        <div style="color: #9e9275;margin-right: 10px;">秒杀活动</div>
        <div style="display: flex">
          {{secKill.msg}}：
          <van-count-down @finish="countTimeFinish" :time="secKill.countTime" format="DD 天 HH 时 mm 分 ss 秒" />
        </div>

      </div>
      <van-cell-group>
        <van-cell>
          <div class="goods-title">
            {{ goods.title }}
            <span class="goods-sub-title">{{ goods.subTitle }}</span>
          </div>
          <div class="goods-price">￥{{ priceRange }}</div>



        </van-cell>
        <van-cell class="goods-express">
          <van-col span="10">运费：{{ goods.freightInfo }}</van-col>
          <!-- <van-col span="14">成交：{{ goods.transactionNum }}</van-col> -->
        </van-cell>
      </van-cell-group>

      <van-cell-group class="goods-cell-group">
        <van-cell value="进入店铺" icon="shop" is-link @click="sorry">
          <template slot="title">
            <span class="van-cell-text" v-text="goods.shopName">有赞的店</span>
            <van-tag class="goods-tag" type="danger">官方</van-tag>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="goods-cell-group">
        <van-cell title="选择" is-link @click="onShowBase" />
        <van-cell title="参数" is-link @click="showParameter=true" />
      </van-cell-group>

      <van-panel title="商品详情">
        <div class="goods-description" v-html="goods.description" ref="goods-description">内容</div>
      </van-panel>

      <van-goods-action>
        <van-goods-action-icon icon="wap-home" @click="$router.push('/home')">首页</van-goods-action-icon>
        <template v-if="bus.state.cartGoodsNum>0">
          <van-goods-action-icon
            icon="shopping-cart-o"
            :info="bus.state.cartGoodsNum"
            @click="onClickCart"
          >购物车</van-goods-action-icon>
        </template>
        <template v-else>
          <van-goods-action-icon icon="shopping-cart-o" @click="onClickCart">购物车</van-goods-action-icon>
        </template>
        <van-goods-action-button :disabled="(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0)" type="warning" @click="onShowBase">{{bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0?'已停用':'加入购物车'}}</van-goods-action-button>
        <van-goods-action-button :disabled="(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0)" type="danger" @click="onShowBase">{{bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0?'已停用':'立即购买'}}</van-goods-action-button>
      </van-goods-action>
    </div>

    <!--商品规格弹出层-->
    <van-sku style="min-height: 80%" v-model="showBase" :sku="sku" :goods="goods" :hide-stock="true" @add-cart="onClickAddCart" @buy-clicked="onClickGoShopping">
        <!-- <div slot="sku-header"></div> -->
      <!--
      <div slot="sku-header-origin-price"></div> -->
      <div slot="sku-header-price" class="van-sku__goods-price">
          <span class="van-sku__price-symbol">￥</span><span class="van-sku__price-num" v-text="priceRange">1.00</span>
      </div>

      <!-- 制式、版本 -->
      <div slot="sku-group">
        <div class="van-sku-group-container van-hairline--bottom">
          <div class="van-sku-row" v-for="item in goods.specifications" :key="item.name">
            <div class="van-sku-row__title" v-text="item.name">顔色</div>
            <span
              class="van-sku-row__item"
              v-for="value in item.values"
              :key="value.name"
              :class="{'van-sku-row__item--disabled': value.noSelect, 'van-sku-row__item--active':item.selectedValue==value.name}"
              @click="onSelectValue(item,value.name)"
            >
              <span class="van-sku-row__item-name" v-text="value.name">天蓝色</span>
            </span>
          </div>
        </div>
      </div>

      <!-- 主售商品 -->
      <!-- 颜色，数量 -->
      <div slot="sku-stepper">
        <div class="van-sku-stepper-stock" v-for="item in selectSkuArray" :key="item.id">
          <div class="van-sku-stepper-container">
            <div class="van-sku__stepper-title">
              {{item.color}}
              <span style="color: #f44">{{item.price | formatPrice}}</span>
              <!-- 会员价 -->
              <!-- <span v-if="item.specialPrice" style="color: #f44">{{item.specialPrice | formatPrice}}</span> -->
            </div>
            <div class="van-sku__stepper van-stepper">
              <van-stepper @minus="buyMainNumMinus()" @change="buyMainNumChange(item)" v-model="item.currentNum" :step="mainSkuStep(item)" :min="item.allBuy ? item.stepperLimit : 0" :max="secKill.exist ? 10000 : item.stepperLimit"/>
            </div>
          </div>
          <div class="van-sku__stock" v-if="secKill.exist && secKill.beginning">有货</div>
          <div class="van-sku__stock" v-else>库存{{item.stock}}件</div>
          <!--<div class="van-sku__quota" v-if="item.quota">本次限购{{item.quota}}件</div>-->
        </div>
      </div>
      <!-- 搭售商品 -->
      <div slot="sku-messages">
        <van-divider v-if="additionalGoodsSkus.length > 0" content-position="center" :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          搭售商品<van-icon name="arrow-down" />
        </van-divider>
        <div v-for="addGoods in additionalGoodsSkus" :key="addGoods.goodsId">
          <van-divider content-position="left">
            {{addGoods.title}} /
            <span v-if="makeUp.fix">需搭 {{addGoods.need}} /</span>
            已选 {{addGoods.selected}}
          </van-divider>
          <div class="van-sku-stepper-stock" v-for="addSku in addGoods.skus" :key="addSku.code">
            <div class="van-sku-stepper-container">
              <div class="van-sku__stepper-title">
                <!-- {{addSku.attributes.版本}} -->
                {{addSku.attributes.制式}}
                {{addSku.attributes.颜色}}
                <span style="color: #f44">{{addSku.price | formatPrice}}</span>
              </div>
              <div class="van-sku__stepper van-stepper">
                <van-stepper :disabled="addSku.stock === 0" @change="buyAddNumChange(addGoods)" :step="1" v-model="addSku.currentNum" :min="addGoodsMinBuyNum(addGoods, addSku)" :max="makeupMax(addSku, addGoods)" />
              </div>
            </div>
            <div class="van-sku__stock">库存{{addSku.stock}}件</div>
          </div>
        </div>
      </div>
    </van-sku>
    <!--参数弹出层 start-->
    <van-popup v-model="showParameter" position="bottom" style="max-height: 80%">
      <van-panel title="基本信息" style="font-weight: 900">
        <van-cell-group style="font-weight: 500; font-size: 14px">
          <template v-for="param in goods.parameter">
            <van-cell v-for="item in param.generalProperties" :key="item.name">
              <span style="color: #888; min-width: 130px; display: inline-block" v-text="item.name"></span>
              <span style="color: #555;" v-text="item.value"></span>
            </van-cell>
          </template>
        </van-cell-group>
      </van-panel>
      <van-button @click="showParameter=false" block>确定</van-button>
    </van-popup>
    <!--参数弹出层 end-->
  </div>
</template>

<script>
import bus from "../../bus";
import {getGoods, listSku, loadCombinationTying, loadSecKill} from "../../api/goods";
import { saveAll } from "../../api/carts";
import { Toast } from "vant";
import goodsSku from "./goods-sku";

export default {
  name: "goods",
  mixins: [goodsSku],
  props: {
    id: String
  },
  data() {
    return {
      activeNames: ['1'],
      cartSubmitFlag: true,
      bus,
      checkSkuArray: [
        /* {
                       color: '黑色',
                       stock_num: 18,
                       id: 2258, // skuId，下单时后端需要
                       price: 100,
                       stepperLimit: 10,
                       currentNum: 0,
                       quota: 10,// 限购 限购数(0表示不限购)
                     }*/
      ],
      goods: {
        title: "加载中",
        freightInfo: "免运费",
        transactionNum: 19,
        thumb: [""],
        picture: "http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/goods_cf73568b63073108f7c29adc5d213002.jpg",
        specifications: [
          {
            name: "制式",
            values: [{ name: "全网通", noSelect: false }],
            selectedValue: "全网通"
          },
          {
            name: "颜色",
            values: [
              { name: "极地白", noSelect: true },
              { name: "暗夜蓝", noSelect: false },
              {
                name: "星空黑",
                noSelect: false
              }
            ],
            selectedValue: "星空黑"
          }
        ]
      },
      additionalGoodsSkus: [],
      makeUp: {
          isMakeUp: false, // 当前商品是否设置组合搭售
          batchId: undefined,
          mainStep: 2,
          mainType: 'SKU',
          mainSkuCode: '10303756101',
          fix: true,
          fixedProportion:false
      },
      skuArray: [
      ],
      showParameter: false,
      secKill: {
        countTime: 0,
        beginning: false,
        upperLimitOfSpu: 0,
        exist: false
      },
      secKillDto: {

      }
    };
  },
  methods: {
    countTimeFinish() {
      if(new Date().getTime() >= this.secKillDto.beginTime && new Date().getTime() < this.secKillDto.endTime) {
        // 开始了
        this.secKill.beginning = true;
        this.secKill.msg = "距结束还剩";
        // 设置倒计时
        this.secKill.countTime = this.secKillDto.endTime - new Date().getTime();
        this.secKill.upperLimitOfSpu = this.secKillDto.upperLimitOfSpu;

      }else {
        this.secKill.beginning = false;
        this.secKill.msg = "秒杀活动结束";
      }

      this.loadSku();
    },
    loadSku() {
      listSku(this.id, data => {
        this.skuArray = data;
      });
    },
    loadCombinationTying() {
      loadCombinationTying(this.id).then(res => {
        if (res.data.exist) {
            this.makeUp.isMakeUp = true;
            this.makeUp.fix = res.data.fix;
            this.makeUp.fixedProportion = res.data.fixedProportion;
            this.makeUp.batchId = res.data.batchId;
            this.makeUp.mainType = res.data.mainType;
            this.makeUp.mainStep = res.data.mainStep;
            this.makeUp.mainSkuCode = res.data.mainSkuCode;
            this.additionalGoodsSkus = res.data.addData;
        }else {
            this.makeUp.isMakeUp = false;
        }
      }).catch(error => {
        Toast("网络出错！");
      })
    },
    // 控制主售商品的购买数量
    buyMainNumChange(currSku) {
      // 如果主售是sku搭售，则在此进行控制
      if (this.makeUp.isMakeUp && this.makeUp.mainType === 'SKU' && currSku.code === this.makeUp.mainSkuCode) {
        currSku.currentNum = Math.floor(currSku.currentNum / this.makeUp.mainStep) * this.makeUp.mainStep
      }
    },
    //实现简单。。。。。主售商品购买数量减少了，就把搭售的置为0
    buyMainNumMinus()  {
      this.additionalGoodsSkus.forEach(goods => {
          goods.skus.forEach(sku => {
            sku.currentNum = 0;
          })
      })
    },
    // 设置每个搭售商品的上限，根据搭售类型不同而不同
    makeupMax(currSku, currGoods) {
      if(this.makeUp.fixedProportion) {
      // if(true) {
          // 如果搭售的是SPU
        if(currGoods.additionalGoodsType === 'SPU') {
          // 此商品需搭 - 当前商品其他sku已选
          const currGoodsNeed = this.toNumber(currGoods.need);
          let currGoodsOtherSkuSelected =  currGoods.skus.filter(sku => sku.id !== currSku.id).reduce((sum, curr) => {
            return sum + curr.currentNum;
          }, 0);
          return currGoodsNeed - currGoodsOtherSkuSelected;
        }else {
          return this.toNumber(this.mainGoodsChangeStepNum) * this.toNumber(currSku.skuStep);
        }
      }
      return currSku.stock;
    },
    toNumber(obj) {
      let v = parseInt(obj);
      return isNaN(v) ? 0 : v;
    },
    buyAddNumChange(currAddGoods) {
      currAddGoods.selected = currAddGoods.skus.reduce((sum, curr) => {
        return sum + curr.currentNum;
      }, 0)
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    onClickHome() {
      this.$router.push("/home");
    },
    formatPrice(price) {
      return "¥" + Number.parseInt(price).toFixed(2);
    },
    onClickCart() {
      this.$router.push("/carts");
    },
    onShowBase(){
        this.showBase = true
    },
    onClickGoShopping() {
      this.cartSubmitFlag = false
      bus.state.cartSubmitFlag = false
      this.onSubmit()
    },
    onClickAddCart() {
      this.cartSubmitFlag = true
      bus.state.cartSubmitFlag = true
      this.onSubmit()
    },
    uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).replace(/[-]/g,"");
    },
    // 购买或加入购物车
    onSubmit() {
      if(this.listBuySku().length==0){
        Toast("请先选择商品");
        return
      }
      if (this.secKill.beginning && this.listBuySku().map(o => o.currentNum).reduce((x,y) => x + y, 0) > this.secKill.upperLimitOfSpu) {
        Toast("秒杀商品，数量限定为" + this.secKill.upperLimitOfSpu);
        return
      }
      // 加购物车
      if (this.cartSubmitFlag) {
        let shopId = this.goods.shopId;
        let carts = this.listBuySku().map(sku => ({
          shopId,
          skuCode: sku.code,
          number: sku.currentNum,
          skuId: sku.id,
          goodsId: this.id,
          stepperLimit: sku.stock,
          allBuy: sku.allBuy
        }));

        // 组合搭售，加批次号
        if (this.makeUp.isMakeUp) {
          carts.forEach(item => {
            item.batchId = this.makeUp.batchId;
            item.allBuy = true;
          })
        }

        saveAll(carts, _ => {
          Toast("加入购物车成功");
        });
      } else {
        //          立即购买
        /*let carts = {
                      "id": 13,
                      "name": "山东宏米通讯",
                      "commodity": [{
                        "title": "红米S2",
                        "standard": "全网通/4+64",
                        "color": "铂银灰",
                        "count": 1,
                        "price": 1139,
                        "thumb": "http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/goods_6d07bda1d030458ba971cab04345af11.png",
                        "skuCode": "1.10.315",
                        "shopId": 13,
                        "skuId": 408,
                        "goodsId": 28
                      }],
                    };*/
        let buy = {
          id: this.goods.shopId,
          name: this.goods.shopName
        };
        buy.commodity = this.listBuySku().map(sku => ({
          title: sku.name,
          standard: sku.attributes["制式"] + "/" + sku.attributes["版本"],
          color: sku.attributes["颜色"],
          count: sku.currentNum,
          price: sku.price,
          // thumb: this.goods.picture,
          thumb: sku.picture,
          skuCode: sku.code,
          shopId: this.goods.shopId,
          skuId: sku.id,
          goodsId: this.id
        }));
        bus.state.buyList = [buy];
        this.$router.push("/order-submit");
      }
      this.showBase = false;
    },
    sorry() {
      Toast("sorry");
    },
    onSelectValue(item, value) {
      if (item.selectedValue === value) {
        item.selectedValue = "";
      } else {
        item.selectedValue = value;
      }
    },
    getSelectSkuArray() {
      let m = new Map();
      this.goods.specifications.forEach(o => {
        if (o.selectedValue !== "") {
          m.set(o.name, o.selectedValue);
        }
      });
      let len = m.size;
      return this.skuArray.filter(sku => {
        let i = 0;
        for (let e of m) {
          let k = e[0];
          let v = e[1];
          if (sku.attributes[k] === v) {
            i++;
          }
        }
        return i === len;
      });
    },
    listBuySku() {
      let resultArray = this.skuArray.filter(sku => sku.currentNum > 0);
      resultArray.forEach(item => item.picture = this.goods.picture)

      // 设置了组合搭售
      if (this.makeUp.isMakeUp) {
        // 验证主售商品选择数量比例是否符合标准
        if (this.makeUp.mainType === 'SPU') {
          let mainBuyNumSum = resultArray.reduce((sum, curr) => {
            return sum + curr.currentNum;
          }, 0)
          if (mainBuyNumSum % this.makeUp.mainStep > 0) {
            Toast(this.goods.title + " 购买总数量不合标准，应为" + this.makeUp.mainStep + "的倍数哦！");
            throw new Error(this.goods.title + " 购买总数量不合标准，应为" + this.makeUp.mainStep + "的倍数哦！")
          }
        }

        // 筛选出搭售商品，并检查搭售商品数量是否符合规则
        this.additionalGoodsSkus.forEach(addGoods => {
          if (this.makeUp.fix && addGoods.need > addGoods.selected) {
            Toast(addGoods.title + " 购买数量不符合要求！");
            throw new Error(addGoods.title + " 购买数量不符合要求！")
          }
          resultArray = addGoods.skus.filter(addSku => {
              if (addSku.currentNum > addSku.stock) {
                Toast(addGoods.title + addSku.attributes.颜色 + " 库存不足！");
                throw new Error(addGoods.title + addSku.attributes.颜色 + " 库存不足！")
              }
              return addSku.currentNum > 0;
            }).map(item => {
              item.picture = addGoods.picture;
              return item;
            })
            .concat(resultArray);
        })
      }

      return resultArray;
    }
  },
  watch: {
    // 已选择的主售商品发生变化
    selectSkuArray: {
      handler(now, previous) {
        // 动态改变每个搭售商品的需搭数量
        if (this.makeUp.fix) {
          this.additionalGoodsSkus.forEach(addGoods => {
            if (addGoods.additionalGoodsType === 'SPU') {
                addGoods.need = this.mainGoodsChangeStepNum * addGoods.spuStep;
            }else {
                addGoods.need = addGoods.skus.reduce((sum,curr) => {
                    curr.currentNum = this.mainGoodsChangeStepNum * curr.skuStep
                    return sum + curr.skuStep;
                }, 0) * this.mainGoodsChangeStepNum;
            }
          });
        }

        // 动态改变搭售已选数量
        this.additionalGoodsSkus.forEach(addGoods => {
          addGoods.selected = addGoods.skus.reduce((sum,curr) => {
                return sum + curr.currentNum;
            }, 0);
        })

        // 判断 需搭/可搭
        // this.additionalGoodsSkus.forEach(addGoods => {
        //     if (this.makeUp.fix) {
        //         addGoods.needMsg = '需搭 ' + addGoods.need;
        //         addGoods.minNeed = addGoods.need;
        //     }else {
        //         if (addGoods.additionalGoodsType === 'SPU') {
        //             let min = 0;
        //             if (this.mainGoodsChangeStepNum > 0) {
        //                 min = addGoods.spuStep;
        //             }
        //             addGoods.needMsg = min === 0 ? '可搭' + min : '可搭 ' + min + ' - ' + addGoods.need;
        //             addGoods.minNeed = min;
        //         }else {
        //             let min = 0;
        //             if (this.mainGoodsChangeStepNum > 0) {
        //                 addGoods.skus.forEach(addSku => {
        //                     if (min === 0 || min > addSku.skuStep) {
        //                         min = addSku.skuStep;
        //                     }
        //                 })
        //             }
        //             addGoods.needMsg = min === 0 ? '可搭' + min : '可搭 ' + min + ' - ' + addGoods.need;
        //             addGoods.minNeed = min;
        //         }
        //     }

        //     // 动态改变搭售已选数量
        //     addGoods.selected = addGoods.skus.reduce((sum,curr) => {
        //         return sum + curr.currentNum;
        //     }, 0);
        // });
      },
      deep: true
    }
  },
  filters: {
    formatPrice(price) {
      return "¥" + Number.parseInt(price).toFixed(2);
    }
  },
  computed: {
    selectSkuArray() {
      this.getSelectSkuArray().forEach(skuItem => {});
      return this.getSelectSkuArray();
    },
    // 获取设置搭售的主售商品的已选择数量
    // 1. 若是SPU分货，则统计所有已选择的主售商品
    // 2. 若是SKU分货，则只统计设置了搭购的主售SKU的选择数量
    mainGoodsSelectedNum() {
      // 此处的主售商品已选择数组，取的之所以不是 'selectSkuArray' 中的，是因为参考了提交时的老代码
      // listBuySku()
      // 提交时的主售商品是否选择的标准只是判断购买数量
      let mianSkusSelected = this.skuArray.filter(sku => sku.currentNum > 0);

      if (mianSkusSelected.length > 0) {
        if (this.makeUp.mainType === 'SPU') {
          return mianSkusSelected.reduce((sum,curr) => {
            return sum + curr.currentNum;
          }, 0);
        } else {
          let eligibleSelectSkuArray = mianSkusSelected.filter(mainSku => {
            return mainSku.code === this.makeUp.mainSkuCode;
          })
          if(eligibleSelectSkuArray.length > 0) {
            return eligibleSelectSkuArray[0].currentNum;
          }else {
            return 0;
          }
        }
      }else {
        return 0;
      }
    },
    // 主售商品按比例变化步数
    mainGoodsChangeStepNum() {
      return this.mainGoodsSelectedNum / this.makeUp.mainStep;
    },
    // 根据主售商品购买情况、组合搭售设置情况，计算每个搭售商品最大购买量
    addGoodsMaxBuyNum() {
      return (currGoods, currSku) => {
        if (this.makeUp.fix) {
          if (currGoods.additionalGoodsType === 'SKU') {
            return this.mainGoodsChangeStepNum * currSku.skuStep;
          }else {
            let otherAddSkuBuyNumSum = currGoods.skus.filter(otherSku => {
              return otherSku.code !== currSku.code;
            }).reduce((sum, curr) => {
              return sum + curr.currentNum;
            }, 0)
            let situationNum = currGoods.need - otherAddSkuBuyNumSum;
            return situationNum
          }
        }else {
          return currSku.stock;
        }
      }
    },
    addGoodsMinBuyNum() {
      return (currGoods, currSku) => {
        if (this.makeUp.fix && currGoods.additionalGoodsType === 'SKU') {
          return this.mainGoodsChangeStepNum * currSku.skuStep;
        }else {
          return 0;
        }
      }
    },
    mainSkuStep() {
      return (currMainSku) => {
        if (this.makeUp.isMakeUp && this.makeUp.mainType === 'SKU' && currMainSku.code === this.makeUp.mainSkuCode) {
          return this.makeUp.mainSkuStep;
        }else {
          return 1;
        }
      }
    },
    priceRange() {
      let priceArray = this.getSelectSkuArray().map(o => o.price);
     if(priceArray.length){
       let maxInNumbers = Math.max.apply(Math, priceArray);
       let minInNumbers = Math.min.apply(Math, priceArray);
       return maxInNumbers === minInNumbers
               ? minInNumbers
               : minInNumbers + "-" + maxInNumbers;
     }
     return  '暂无'

    },
    isGoShopping() {
      return this.listBuySku().length > 0;
    },
  },
  mounted() {
    getGoods(this.id, data => {
        this.goods = data;
        if (this.goods.enableSecKill) {
          this.secKill.exist = true;
          loadSecKill(this.id, data => {
            if (data) {
              this.secKillDto = data;
              // 先判断是否开始
              if(data.beginTime <= new Date().getTime()) {
                // 开始了
                this.secKill.beginning = true;
                this.secKill.msg = "距结束还剩";
                // 设置倒计时
                this.secKill.countTime = data.endTime - new Date().getTime();
                this.secKill.upperLimitOfSpu = data.upperLimitOfSpu;
              }else {
                this.secKill.msg = "距开始还剩";
                this.secKill.countTime = data.beginTime - new Date().getTime();
              }
            }
          });
        }

        // 为图片设置最大宽度 防止超出
        setTimeout(() => {
            let imgs = this.$refs['goods-description'].getElementsByTagName('img');
            for (let el of imgs) {
                el.style.cssText = 'max-width:100%';
            }
        }, 200)
    });
    listSku(this.id, data => {
        this.skuArray = data;
    });
    this.loadCombinationTying();
  }
};
</script>

<style lang="less" scoped>
  .sec-kill{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: rgba(255,255,255,.8);
    position: relative;
    margin-top: -50px;
    font-size: 14px;
    color: #ee0a24;
  }
  .colon {
    display: inline-block;
    margin: 0 4px;
    color: #ee0a24;
  }
  .block {
    display: inline-block;
    width: 22px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background-color: #ee0a24;
  }

.arrow-left {
  margin-left: 15px;
  color: #cccccc;
  font-weight: 700;
}

.home {
  float: right;
  margin-right: 15px;
  color: #cccccc;
  font-weight: 700;
}
.goods {
  margin-bottom: 50px;
  &-swipe {
    img {
      width: 7.5rem;
      height: 7.5rem;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }
  &-sub-title {
    font-size: 12px;
  }
  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-description {
    img {
      max-width: 100%;
    }
  }
  &-tag {
    margin-left: 5px;
  }

  .van-goods-action {
    z-index: 10;
  }
}
</style>
